(function () {
	/**
	 * Renders Weather Station Detail Page (new stations-data/*.json structure)
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object}    Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderWeatherStationPage = function (props) {
		var Utils = WebBaseAprovLV.Utils;
		var lang = WebBaseAprovLV.lang;
		var params = {
			page: (props.context.params && props.context.params.page) || '',
			detail: (props.context.params && props.context.params.detail) || '',
			filter: props.scodeFilter || ''
		};
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			console.error('[station-detail] Utils missing');
			return $.Deferred().reject(new Error('Utils missing')).promise();
		}
		var fetchFresh = Utils.fetchAsync({ dataType: 'json', cache: false, timeout: 12000 });
		function safeJSON(call, defaultVal, label) {
			var dfd = $.Deferred();
			call
				.done(function (resp) { dfd.resolve(resp); })
				.fail(function (_jq, textStatus, err) {
					console.warn('[station-detail] failed:', label || 'request', textStatus || '', err || '');
					dfd.resolve(defaultVal);
				});
			return dfd.promise();
		}
		var stationType = 'valley';
		var stationsUrl = 'stations-data/website/valley.json';
		if (params.filter === 'WS.SF') {
			stationType = 'mountain';
			stationsUrl = 'stations-data/website/mountain.json';
		} else if (params.filter === 'PG') {
			stationType = 'watercourse';
			stationsUrl = 'stations-data/website/watercourse.json';
		}
		var model = {
			element: null,
			template: 'templates/weather-station.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {},
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				alternateRouting: null,
				stationType: stationType,
				stationDataDate: null,
				selectedStation: params.detail || '',
				selectedStationData: null,
				stations: null,
				sensors: null,
				timeseries: null
			}
		};
		var altRoutes = (Utils.getAlternateMeteoStationRouting(params.page) || {});
		var base = (WebBaseAprovLV.config.azureStorageUrl && WebBaseAprovLV.config.azureStorageUrl[lang]) || '';
		return $.when(
			Utils.getKKData('?system.type=page&elements.url[in]=' + encodeURIComponent(params.page) + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
			.then(function (pageXhr) {
				var pageRaw = Array.isArray(pageXhr) ? (pageXhr[0] || {}) : (pageXhr || {});
				model.data.pageRaw = pageRaw;
				model.data.navRaw = {};
				var perStationUrl = 'stations-data/website/' + stationType + '/' + encodeURIComponent(params.detail) + '.json';
				return $.when(
					safeJSON(fetchFresh(base + stationsUrl), { stations: [] }, 'stations'),
					safeJSON(fetchFresh(base + 'stations-data/website/sensor_type.json'), { sensor_type: [] }, 'sensor_types'),
					safeJSON(fetchFresh(base + perStationUrl), { station_code: params.detail, sensors: [] }, 'timeseries')
				);
			})
			.then(function (stationsResp, sensorTypeResp, timeseriesResp) {
				var stationsPayload = stationsResp || { stations: [] };
				var sensorTypePayload = sensorTypeResp || { sensor_type: [] };
				var tsPayload = timeseriesResp || { station_code: params.detail, sensors: [] };
				var sensorTypes = {};
				if (sensorTypePayload && Array.isArray(sensorTypePayload.sensor_type)) {
					sensorTypePayload.sensor_type.forEach(function (st) {
						if (st && st.code) {
							sensorTypes[String(st.code)] = st;
						}
					});
				}
				var stations = [];
				if (stationsPayload && Array.isArray(stationsPayload.stations)) {
					stations = stationsPayload.stations.map(function (s) {
						if (!s) { return s; }
						var name;
						switch (lang) {
							case 'de':
								name = s.name_de || s.name_it || s.name_en || s.name_lld;
								break;
							case 'it':
								name = s.name_it || s.name_de || s.name_en || s.name_lld;
								break;
							case 'lld':
								name = s.name_lld || s.name_de || s.name_it || s.name_en;
								break;
							case 'en':
								name = s.name_en || s.name_de || s.name_it || s.name_lld;
								break;
							default:
								name = s.name_de || s.name_it || s.name_en || s.name_lld;
								break;
						}
						s.NAME = name || s.code || '';
						s.SCODE = s.code || '';
						s.elevation = s.elevation != null
							? parseInt(s.elevation, 10)
							: (s.ALT != null ? parseFloat(s.ALT) : null);
						return s;
					});
					stations.sort(function (a, b) {
						return String(a.NAME || '').localeCompare(String(b.NAME || ''));
					});
				}
				var selectedStationData = null;
				if (stations && stations.length) {
					selectedStationData = stations.find(function (st) {
						return (st.SCODE || st.code || '') === params.detail;
					}) || null;
				}
				if (params.detail && !selectedStationData) {
					console.warn('[station-detail] station not found:', params.detail);
					return WebBaseAprovLV.render404();
				}
				var sensors = [];
				if (selectedStationData && Array.isArray(selectedStationData.statistics)) {
					selectedStationData.statistics.forEach(function (stat) {
						if (!stat) { return; }
						var code = stat.sensorCode != null ? String(stat.sensorCode)
							: (stat.sensor_code != null ? String(stat.sensor_code) : null);
						if (!code) { return; }
						var meta = sensorTypes[code] || {};
						var rawVal = (stat.sensorValue != null ? stat.sensorValue : stat.sensor_value);
						var numVal = null;
						if (typeof rawVal === 'number') {
							numVal = rawVal;
						} else if (typeof rawVal === 'string' && rawVal.indexOf(':') === -1) {
							var parsed = parseFloat(rawVal.replace(',', '.'));
							if (!isNaN(parsed)) { numVal = parsed; }
						}
						var sensor = {
							SCODE: selectedStationData.SCODE || selectedStationData.code || '',
							TYPE: code,
							UNIT: meta.unit || '',
							DESC_D: meta.name_de || '',
							DESC_I: meta.name_it || meta.name_de || '',
							DESC_L: meta.name_lld || meta.name_de || '',
							DESC_E: meta.name_en || meta.name_de || '',
							VALUE: rawVal,
							LASTDATE: stat.sensorLastValidDate || stat.last_date || null
						};
						if (code === 'GS' && numVal != null) {
							sensor.VALUE = Math.round(numVal);
						}
						if ((code === 'WG' || code === 'WG.BOE') && numVal != null) {
							sensor.VALUE = (numVal * 3.6).toFixed(1);
							sensor.UNIT = 'km/h';
						}
						if (code === 'LF' && numVal != null) {
							var rhVal = Math.min(100, Math.round(numVal));
							sensor.VALUE = rhVal;
							sensor.UNIT = '%';
						}
						if (code === 'SSD' || code === 'SD') {
							if (typeof rawVal === 'number' && isFinite(rawVal)) {
								var totalSeconds = rawVal;
								var hours = Math.floor(totalSeconds / 3600);
								var minutes = Math.floor((totalSeconds % 3600) / 60);
								sensor.VALUE = hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
							} else if (typeof rawVal === 'string') {
								sensor.VALUE = rawVal;
							}
							sensor.UNIT = 'h:mm';
						}
						switch (lang) {
							case 'de':
								sensor.DESC = sensor.DESC_D || sensor.DESC_I || sensor.DESC_E || sensor.DESC_L;
								break;
							case 'it':
								sensor.DESC = sensor.DESC_I || sensor.DESC_D || sensor.DESC_E || sensor.DESC_L;
								break;
							case 'lld':
								sensor.DESC = sensor.DESC_L || sensor.DESC_D || sensor.DESC_I || sensor.DESC_E;
								break;
							case 'en':
								sensor.DESC = sensor.DESC_E || sensor.DESC_D || sensor.DESC_I || sensor.DESC_L;
								break;
							default:
								sensor.DESC = sensor.DESC_D || sensor.DESC_I || sensor.DESC_E || sensor.DESC_L;
								break;
						}
						sensors.push(sensor);
					});
				}
				var timeseriesData = {};
				if (tsPayload && Array.isArray(tsPayload.sensors)) {
					tsPayload.sensors.forEach(function (tsSensor) {
						if (!tsSensor || !tsSensor.sensor_code) { return; }
						var code = String(tsSensor.sensor_code);
						var values = Array.isArray(tsSensor.values) ? tsSensor.values.slice() : [];
						values = values.filter(function (v) {
							if (!v || !v.timestamp) { return false; }
							if (v.valid != null && String(v.valid).toLowerCase() === 'false') { return false; }
							return v.value != null && v.value !== '';
						});
						timeseriesData[code] = values;
					});
				}
				sensors = sensors.map(function (sensor) {
					if (sensor.TYPE === 'N' || sensor.TYPE === 'SD') {
						var tsData = timeseriesData[sensor.TYPE];
						if (Array.isArray(tsData) && tsData.length) {
							var latestDay = '';
							tsData.forEach(function (record) {
								var d = new Date(record.timestamp);
								if (!d || isNaN(d.getTime())) { return; }
								var dayStr = d.getFullYear() + '-' +
									('0' + (d.getMonth() + 1)).slice(-2) + '-' +
									('0' + d.getDate()).slice(-2);
								if (dayStr > latestDay) { latestDay = dayStr; }
							});
							if (latestDay) {
								var cumulative = 0;
								tsData.forEach(function (record) {
									var d = new Date(record.timestamp);
									if (!d || isNaN(d.getTime())) { return; }
									var dayStr = d.getFullYear() + '-' +
										('0' + (d.getMonth() + 1)).slice(-2) + '-' +
										('0' + d.getDate()).slice(-2);
									if (dayStr === latestDay) {
										var val = parseFloat(String(record.value).replace(',', '.'));
										if (!isNaN(val)) { cumulative += val; }
									}
								});
								if (sensor.TYPE === 'SD') {
									var totalSeconds = cumulative;
									if (typeof totalSeconds === 'number' && isFinite(totalSeconds)) {
										var hours = Math.floor(totalSeconds / 3600);
										var minutes = Math.floor((totalSeconds % 3600) / 60);
										sensor.VALUE = hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
									}
									sensor.UNIT = 'h:mm';
								} else if (sensor.TYPE === 'N') {
									sensor.VALUE = cumulative;
								}
							}
						}
					}
					return sensor;
				});
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: (Utils.getKKViewModel(model.data.pageRaw)[0]) || {},
					nav: (Utils.getKKViewModel(model.data.navRaw)[0]) || {},
					alternateRouting: altRoutes,
					stationType: stationType,
					stationDataDate: (typeof stationsPayload.date === 'string' && stationsPayload.date.trim()) ? stationsPayload.date.trim() : null,
					selectedStation: params.detail,
					selectedStationData: selectedStationData,
					stations: stations,
					sensors: sensors,
					sensorTypes: sensorTypes,
					timeseries: timeseriesData
				});
				return Utils.transitionTo(model);
			})
			.then(function (ejsmodel) {
				ejsmodel.data.UILangSwitch = Utils.tuneUILangSwitchers({
					page: {
						segment: {
							'de': (altRoutes.de || '') + '/' + (params.detail || ''),
							'it': (altRoutes.it || '') + '/' + (params.detail || ''),
							'lld': (altRoutes.lld || '') + '/' + (params.detail || ''),
							'en': (altRoutes.en || '') + '/' + (params.detail || '')
						}
					},
					detail: {
						id: (('' || {}).system_id || '')
					}
				}, $('a.langchange'));
				return ejsmodel;
			})
			.promise();
	};
})();
